
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 600 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-mercury",attrs:{"fill":"#D0EFEC","d":"M44 300A256 256 0 0 1 428 78.298L377.538 165.7a155.09 155.09 0 0 0-155.076 0 155.1 155.1 0 0 0-56.762 56.762A155.1 155.1 0 0 0 144.924 300z"}})])
          )
        }
      }
    